<template>
    <GetStartedLayout class="white" :errors="errors">
        <v-container class="flex justify-center align-start">
            <div class="flex-col">
                <VueLottiePlayer
                    path="https://assets3.lottiefiles.com/packages/lf20_no08B3.json"
                    background="transparent"
                    style="width: inherit; height: 300px"
                    speed="1"
                    loop
                    autoplay
                ></VueLottiePlayer>
                <v-card-title class="soli-grey justify-center"
                    >We got your message!</v-card-title
                >
                <v-card-subtitle
                    class="soli-grey"
                    style="text-align: center; white-space: pre-line"
                    >We’re excited to talk to you more about music lessons.
                    You’ll get an email with helpful links right away, and one
                    of our teachers will be in touch shortly.</v-card-subtitle
                >
                <SoliBtn
                    class="justify-center w-full"
                    text="Return Home"
                    :href="route('login')"
                    gradient="gradient-blue"
                ></SoliBtn>
            </div>
        </v-container>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import VueLottiePlayer from "vue-lottie-player";
import confetti from "canvas-confetti";

export default {
    components: {
        GetStartedLayout,
        VueLottiePlayer,
    },
    props: ["errors"],
    mounted() {
        console.log(this.errors);
        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 },
        });
    },
};
</script>
